import React from "react";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import SettingSwitch from "@limitless/modern/inputs/setting-switch/SettingSwitch";
import { useExpertProfileContext } from "@limitless/expert";

const items = [
    {
        key: "receiveEmailTaskNotifications",
        titleText: "Email notifications",
        subTitleText: "Never miss a new task and get notified of new earning opportunities."
    },
    {
        key: "receiveBrowserTaskNotifications",
        titleText: "Browser notifications",
        subTitleText: "Never miss a task when using a web browser. You will also need to allow notifications in the browser of your choice."
    },
    {
        key: "receiveMobileTaskNotifications",
        titleText: "Mobile notifications",
        subTitleText:
            "We recommend you keep the mobile notifications on so you get notified of new earning opportunities."
    },
    {
        key: "receiveEmailMarketing",
        titleText: "Limitless marketing emails",
        subTitleText:
            "Stay up to date about the latest earning opportunities within our community. We promise to not spam you."
    },
    {
        key: "receiveThirdPartyEmails",
        titleText: "Emails from trusted third parties and partners",
        subTitleText: "Once in a while, you might receive emails from our carefully selected partners or third parties."
    },
    {
        key: "suggestedAnswerEnabled",
        titleText: "Enable suggested answers"
    }
];

const AppSettings = () => {
    const { profile, saveProfile } = useExpertProfileContext();

    const getAppSettingsItems = React.useMemo(() => {
        return items?.map(item => ({
            ...item,
            checked: profile[item.key],
            handleSwitchChange: () => saveProfile({ [item.key]: !profile[item.key] })
        }));
    }, [profile]);

    return (
        <Grid mt={theme => theme.spacing(3)}>
            <SettingSwitch items={getAppSettingsItems} showAnimation />
        </Grid>
    );
};

export default AppSettings;
